import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  dadoEspelho: {
    fontSize: '13px',
  },
}))

export default useStyles
